import { DOWNLOAD_IMAGES_JOB_KEY, JOB_TTL_MS } from '@/lib/constants/job';
import { streamSignedUrlsToZip } from '@/lib/download/streaming-zip-download';
import {
  DownloadSignedUrlsProgress,
  DownloadSignedUrlsResult,
  SignedUrlEntry,
} from '@/types/download';
import { PersistedJob } from '@/types/job';

export async function downloadSignedUrls(
  signedUrls: SignedUrlEntry[],
  zipName: string,
  // eslint-disable-next-line no-unused-vars
  onProgress?: (progress: DownloadSignedUrlsProgress) => void,
  saveHandle?: FileSystemFileHandle | null,
  signal?: AbortSignal,
): Promise<DownloadSignedUrlsResult> {
  if (signedUrls.length === 0) {
    return { downloaded: 0, failedCount: 0 };
  }

  return streamSignedUrlsToZip(signedUrls, zipName, saveHandle, onProgress, signal);
}

export function persistDownloadJob(jobId: string, zipName: string): void {
  if (typeof window === 'undefined') return;
  const payload: PersistedJob = {
    jobId,
    enqueuedAt: Date.now(),
    zipName,
  };
  localStorage.setItem(DOWNLOAD_IMAGES_JOB_KEY, JSON.stringify(payload));
}

export function getPersistedDownloadJob(key: string): PersistedJob | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedJob;
    if (
      !parsed ||
      typeof parsed.jobId !== 'string' ||
      typeof parsed.enqueuedAt !== 'number' ||
      typeof parsed.zipName !== 'string'
    ) {
      localStorage.removeItem(key);
      return null;
    }
    if (Date.now() - parsed.enqueuedAt > JOB_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function clearPersistedDownloadJob(key: string): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(key);
}
